// import { DropDownList } from './custome/ddl.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SisDropdownModule } from '@modules/components/sis-dropdown/sis-dropdown.module';
/* panel */
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
/* buttom */
import { ButtonModule } from 'primeng/button';
/* input */
import { DatePickerModule } from 'primeng/datepicker';
import { CardModule } from 'primeng/card';
/* data */
import { CarouselModule } from 'primeng/carousel';
/* chart */
// import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
/* overlay */
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
// import { DataGridModule } from 'primeng/datagrid';
// import { DataListModule } from 'primeng/datalist';
// import { DataScrollerModule } from 'primeng/datascroller';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
/* drag , deop */
import { DragDropModule } from 'primeng/dragdrop';
// import { EditorModule } from 'primeng/editor';
import { DrawerModule } from 'primeng/drawer';
import { FieldsetModule } from 'primeng/fieldset';
import { FloatLabelModule } from 'primeng/floatlabel';
/* file*/
import { FileUploadModule } from 'primeng/fileupload';
/* multimedia */
import { GalleriaModule } from 'primeng/galleria';
import { InputNumberModule } from 'primeng/inputnumber';
// import { GrowlModule } from 'primeng/growl';
// DELETE: will not work with ngx-mask 🔴🔴🔴
// import { InputMaskModule } from 'primeng/inputmask';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
/* menu */
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { PopoverModule } from 'primeng/popover';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
// import { ScheduleModule } from 'primeng/schedule';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SliderModule } from 'primeng/slider';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

@NgModule({
	imports: [CommonModule],
	exports: [
		DatePickerModule,
		SelectModule,
		InputTextModule,
		TextareaModule,
		InputNumberModule,
		ListboxModule,
		MultiSelectModule,
		RadioButtonModule,
		SliderModule,
		SelectButtonModule,
		AutoCompleteModule,
		CheckboxModule,
		ColorPickerModule,
		// EditorModule,
		ToggleSwitchModule,
		// InputMaskModule,
		PasswordModule,
		RatingModule,
		ToggleButtonModule,
		ButtonModule,
		SplitButtonModule,
		CarouselModule,
		OrganizationChartModule,
		PickListModule,
		TableModule,
		TreeTableModule,
		DataViewModule,
		OrderListModule,
		PaginatorModule,
		TreeModule,
		AccordionModule,
		FieldsetModule,
		ScrollPanelModule,
		TabsModule,
		CardModule,
		PanelModule,
		ToolbarModule,
		ConfirmDialogModule,
		PopoverModule,
		DialogModule,
		DrawerModule,
		TooltipModule,
		FileUploadModule,
		FloatLabelModule,
		MenuModule,
		ContextMenuModule,
		PanelMenuModule,
		StepsModule,
		TieredMenuModule,
		BreadcrumbModule,
		MegaMenuModule,
		MenubarModule,
		MessageModule,
		// GrowlModule,
		GalleriaModule,
		DragDropModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		SisDropdownModule,
		KeyFilterModule,
		ToastModule,
		ChipModule,
	],
})
export class PrimengModule {}
